/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Cancel_DownloadInputs */

const en_mobile_cancel_download = /** @type {(inputs: Mobile_Cancel_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel download`)
};

const es_mobile_cancel_download = /** @type {(inputs: Mobile_Cancel_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar descarga`)
};

/**
* | output |
* | --- |
* | "Cancel download" |
*
* @param {Mobile_Cancel_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_cancel_download = /** @type {((inputs?: Mobile_Cancel_DownloadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Cancel_DownloadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_cancel_download(inputs)
	return en_mobile_cancel_download(inputs)
});